import { render, staticRenderFns } from "./InternalsList.vue?vue&type=template&id=5cfcd2f8"
import script from "./InternalsList.vue?vue&type=script&lang=js"
export * from "./InternalsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports